import { RouterModule, Routes } from '@angular/router';

const errorRoutes: Routes = [
  {
    path: 'error',
    loadChildren: () =>
      import('./unauthorized/unauthorized-routing.module').then(
        (m) => m.UnauthorizedErrorRoutingModule,
      ),
  },
];
export default errorRoutes;
